export const resolveCountryCodeFromLanguage = (languageCode?: string | null): string => {
    const normalized = (languageCode ?? '').toLowerCase();

    if (normalized.startsWith('fr')) {
        return 'fr-FR';
    }

    if (normalized.startsWith('pt')) {
        return 'pt-PT';
    }

    return 'en-US';
}

export const getDetectedCountryCode = (): string => {
    const globalCountryCode = window.appointmintDetectedCountryCode;
    if (typeof globalCountryCode === 'string' && globalCountryCode.length > 0) {
        return globalCountryCode;
    }

    if (typeof window.detectCountryCode === 'function') {
        return window.detectCountryCode();
    }

    return resolveCountryCodeFromLanguage(navigator.language);
}
